import { render, staticRenderFns } from "./OtherSetting.vue?vue&type=template&id=0f67acb2&scoped=true&"
import script from "./OtherSetting.vue?vue&type=script&lang=js&"
export * from "./OtherSetting.vue?vue&type=script&lang=js&"
import style0 from "./OtherSetting.vue?vue&type=style&index=0&id=0f67acb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f67acb2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
